import { useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';
import * as S from './styles';
import { getUser } from '../../../modules/Redux';
import { auth } from '../../../modules/Lib/firebase';
import { signOut } from 'firebase/auth';
import { Button, Container, Title } from '../../components';

const NoStoreFound = () => {
    const theme = useTheme();
    const user = useSelector(getUser);

    return (
        <Container>
            <Title>No Store Found</Title>
            <S.Subcontainer>
                <S.Label>Signed in with</S.Label>
                <S.Text>{user?.number}</S.Text>
                <S.Text2>{user?.email}</S.Text2>

                <S.Label>Please call support at</S.Label>
                <S.Text>(866) 868-2146</S.Text>
            </S.Subcontainer>

            <Button
                theme={theme}
                type="button"
                onClick={() => void signOut(auth)}
            >
                Sign In with New Number
            </Button>
        </Container>
    );
};

export default NoStoreFound;
